export default "__VITE_PUBLIC_ASSET__d71514c0__"